import React, { useState } from 'react';
import './App.css';
import Background from './Background';
import Widget from './Widget';
import { fetchWeather } from './FetchWeather';
import bk1 from './icons/bk1.jpg';


function App() {
  const [query, setQuery] = useState('');
  const [weather, setWeather] = useState({});
  
  
  const search = async (e) => {
      if(e.key === 'Enter') {
          const data = await fetchWeather(query);
          setWeather(data);
          console.log(data);
          setQuery('')
      }
  }
  return (
    <div className="App">
      <input
            type="text"
            className="search"
            placeholder="Enter city...or city,country"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyPress={search}
      />    
      
      {weather.data && ( <>
        <Background weatherData={weather}/>
      <Widget weatherData={weather}/>
      </>
      )}
    </div>
  );
}

export default App;
